import React from "react";
import { Navbar, Nav, Container, Button, Badge } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaReceipt,
  FaChartLine,
  FaMapMarkerAlt,
  FaSignOutAlt,
  FaUser,
} from "react-icons/fa";

const Navigation = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    localStorage.removeItem("expires_in");
    localStorage.removeItem("last_updated");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
      <Container fluid>
        <Navbar.Brand as={Link} to="/receipts">
          POS Dashboard
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {/* <Nav.Link as={Link} to="/summaries">
              <FaChartLine className="me-1" />
              Summaries
            </Nav.Link> */}
            <Nav.Link as={Link} to="/receipts">
              <FaReceipt className="me-1" />
              Summaries
            </Nav.Link>
            <Nav.Link as={Link} to="/locations">
              <FaMapMarkerAlt className="me-1" />
              Locations
            </Nav.Link>
          </Nav>

          {user && (
            <div className="d-flex align-items-center mx-3">
              <div className="text-white me-3 d-flex align-items-center">
                <FaUser className="me-2" />
                <span className="me-2">{user.username}</span>
                {user.branch_name && (
                  <Badge bg="secondary" className="me-2">
                    {user.branch_name}
                  </Badge>
                )}
                <Badge bg="info" className="me-2">
                  Branch: {user.branch_id}
                </Badge>
                {user.role && <Badge bg="secondary">{user.role}</Badge>}
              </div>
              <Button
                variant="outline-light"
                size="sm"
                onClick={handleLogout}
                className="d-flex align-items-center"
              >
                <FaSignOutAlt className="me-1" />
                Logout
              </Button>
            </div>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
